<template>
  <div>
    <b-button class="mb-2" size="sm" :disabled="disabled" variant="primary" @click="getListaSolicitud()">
      <b-icon icon="arrow-clockwise"></b-icon>
      Actualizar
    </b-button>
    <b-table ref="table" striped  responsive hover  stacked="md"
      :items="getListaSolicitud"
      @sort-changed="sortChanged"
      :fields="this.fields"
      :current-page="currentPage"
      :busy.sync="isBusy"
      :per-page="perPage"
      :small="true"
      :sort-by.sync="sortBy">
      <template #cell(EstadoSolicitudMedicaString)="row">
      <b-badge variant="primary" class="mr-1">{{ row.value }}</b-badge>
      </template>
      <!-- <template #cell(acciones)="row">
        <b-button @click.stop="modalAgregarCargo(row.item, row.index, $event.target)"
          v-if="isInRoleAdmin &&(row.item.EstadoSolicitudMedicaString === 'Enviado')"
          variant="primary" size="sm" class="mr-0"
          title="Agregar Cargo">
          <b-icon icon="plus"></b-icon>
        </b-button>
      </template> -->
      <template #cell(NivelEnseñanza_Id)="row">
        {{ row.value ? row.value : 'Sin Nivel' }}
      </template>
      <template #cell(FechaCreacion)="row">{{ row.value | moment('YYYY-MM-DD') }}</template>
      <template #cell(FechaPresentacion)="row">{{ row.value | moment('YYYY-MM-DD') }}</template>
      <template slot="table-caption">
      <small><b>Total solicitudes enviadas: </b></small> <b-badge variant="success">{{ this.totalRows }}</b-badge><small> | <b>Ordenado por : </b>{{ sortBy }}</small>
      </template>
    </b-table>

    <b-row>
      <b-col md="6">
        <b-pagination @input="getListaSolicitud()" size="sm"
          :total-rows="this.totalRows"
          :per-page="perPage"
          v-model="currentPage" />
      </b-col>
      <b-col md="6">
        <b-form-group breakpoint="sm" class="mb-3">
          <b-form-select size="sm" :options="pageOptions" v-model="perPage"/>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import swalerts from "@/helpers/swalerts";
import errorhandler from "@/helpers/errorhandler";
import { mapGetters,mapActions } from 'vuex'
import Solicitudsvc from '@/services/solicitudes'

export default {
  mixins: [errorhandler, swalerts],
  name: "TablaHistorialSolicitud",
  computed: {
    ...mapGetters(['getEstablecimiento']),
  },
  props: {
    personal: Object
  },
  watch: {
    'getEstablecimiento': function (newvalue, oldvalue) {
      console.log('refresh table newvalue oldvalue', newvalue, oldvalue);
      this.$refs.table.refresh();
    }
  },
  data() {
    return {
      disabled: false,
      isBusy: false,
      lista: [],
      sortBy: 'Id',
      sortOrder: 'desc',
      totalRows:null,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15],
      fields: [
        {
          key: 'Id',
          label: 'Id',
          sortable: true,
          class: 'text-center',
          thStyle: {
              maxWidth: '80px',
              minWidth: '80px'
          }
        },
        {
          key: 'PersonalString',
          label: 'DNI - Personal',
        },
        {
          key: 'EnviadoHacia',
          label: 'Autorizado en',
        },
        {
          key: 'FechaCreacion',
          label: 'F. de Envio',
        },
        {
          key: 'EstadoSolicitudMedicaString',
          label: 'Estado',
        },
        {
          key: 'acciones',
          label: 'Acciones',
        },
      ]
    }
  },
  methods: {
    sortChanged: function(e){
      console.log('sortChanged', e);
      this.sortOrder = e.sortDesc ? 'desc' : 'asc';
    },
    getListaSolicitud: function ()
    {
      console.log('getListaSolicitud', this.currentPage, this.perPage, this.personal.Id);

      let promise = Solicitudsvc.getLista({
        sort: 3,
        order: this.sortOrder,
        offset:(this.currentPage-1) * this.perPage,
        limit: this.perPage,
        personal_id: this.personal.Id
      });
      return promise.then(r => {
        console.log("getListaSolicitud then", r);
        this.totalRows = r.data.total;

        this.disabled = false;
        return r.data.rows;
      }).catch(error=>{

        this.disabled = false;
        console.log("Error en getListaSolicitud", error);
        this.errorHandler(e);
      })
    },
  }

};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/TablaHistorialSolicitud.vue